var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"custom-class":"need-login-dialog","visible":_vm.visible,"modal-append-to-body":""},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('div',{staticClass:"need-login-dialog-content"},[_c('div',[_vm._v("该功能请登录后使用")]),_c('div',{staticClass:"primary-btn",on:{"click":_vm.toLogin}},[_vm._v("立即登录")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }